/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_MAILTPLS (state, mailtpls) {
    state.mailtpls = mailtpls
  },
  REMOVE_RECORD (state, itemId) {
    const mailtplIndex = state.mailtpls.findIndex((u) => u.id === itemId)
    state.mailtpls.splice(mailtplIndex, 1)
  }
}
